import { getClaims, fileClaim } from '../utils/apiService';

export const LIST_CLAIMS = 'claim/LIST_CLAIMS';
export const LIST_CLAIMS_PENDING = 'claim/LIST_CLAIMS_PENDING';
export const LIST_CLAIMS_REJECTED = 'claim/LIST_CLAIMS_REJECTED';
export const LIST_CLAIMS_FULFILLED = 'claim/LIST_CLAIMS_FULFILLED';

export const FILE_CLAIM = 'claim/FILE_CLAIM';
export const FILE_CLAIM_PENDING = 'claim/FILE_CLAIM_PENDING';
export const FILE_CLAIM_REJECTED = 'claim/FILE_CLAIM_REJECTED';
export const FILE_CLAIM_FULFILLED = 'claim/FILE_CLAIM_FULFILLED';


export const createClaim = (claim) => {
    const payload = fileClaim(claim);
    return {
        type: FILE_CLAIM,
        payload
    }
}

export const listClaims = () => {
    const payload = getClaims();
    return {
       type: LIST_CLAIMS,
       payload
   }
}


// WEBPACK FOOTER //
// ./src/actions/claims.js